module.exports = "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+cGhvbmUyPC90aXRsZT4KPHN0eWxlPgpzdmd7CiAgZmlsbDogd2hpdGU7Cn0KPC9zdHlsZT4KPHBhdGggZD0iTTIyIDIwYy0yIDItMiA0LTQgNHMtNC0yLTYtNC00LTQtNC02IDItMiA0LTQtNC04LTYtOC02IDYtNiA2YzAgNCA0LjEwOSAxMi4xMDkgOCAxNnMxMiA4IDE2IDhjMCAwIDYtNCA2LTZzLTYtOC04LTZ6Ij48L3BhdGg+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/container/index/images/icons/phone2.svg
// module id = 43
// module chunks = 0